export { SUBSCRIBE_ALL, UFOGlobalEventStreamEventType } from '@atlassian/ufo-experimental/types';
export let TenantType = /*#__PURE__*/function (TenantType) {
  TenantType["RealUser"] = "real-user";
  TenantType["Synthetic"] = "synthetic";
  return TenantType;
}({});